module.exports = __webpack_public_path__ + "static/media/tittle1.5375333c.jpg";